export const imgRegex = /data:image\/[^;]+;base64,([^"]+)/;
export const whiteSpaceEmptyStrRegex = /^\s*$/;
export const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
export const nameRegex =
  /^(?=.*[\p{L}\p{M}])[\p{L}\p{M}]+(?:[ '\u2019-][\p{L}\p{M}]+)*$/u;
export const phoneNoRegex =
  /^([789]{1})([\d]{3})[(\D\s)]?[\d]{3}[(\D\s)]?[\d]{3}$/;
export const indiaPhoneRegex =
  /^(\+91[\s-]?|91[\s-]?|0)?[6-9]\d{9}$/;
export const dateTimeRegex =
  /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})?$/;
export const dateRegex =
  /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})?$|^\d{2}-\d{4}$/;
export const emailccRegex =
  /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}\b/;
